"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var buildMainRouteDisplays = function buildMainRouteDisplays(routes) {
  return routes.reduce(function (displays, route) {
    displays[route.id] = false;
    return displays;
  }, {});
};

var buildCategoryDisplays = function buildCategoryDisplays(categories) {
  var displays = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  categories.forEach(function (category) {
    if (category.children === 0) return;
    displays[category.slug] = false;
    buildCategoryDisplays(category.children, displays);
  });
  return displays;
};

var buildMenuItemDisplays = function buildMenuItemDisplays(props) {
  return Object.assign({}, buildMainRouteDisplays(props.routes.mainRoutes), buildCategoryDisplays(props.categories));
};

var getSubMenuHeight = function getSubMenuHeight(id, state) {
  return state.menuItemDisplays[id] ? "auto" : 0;
};

var getExpandSymbol = function getExpandSymbol(id, state) {
  return state.menuItemDisplays[id] ? "-" : "+";
};

exports.default = {
  buildMenuItemDisplays: buildMenuItemDisplays,
  getSubMenuHeight: getSubMenuHeight,
  getExpandSymbol: getExpandSymbol
};